import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada';
import limparViagens from '../../actions/viagem/limpaViagens';
import { isAmbienteDev } from '../../util/applicationContext';
import elementosPaginaAtual from '../../util/elementosPaginaAtual';
import OpcoesPaginacaoSelecaoEmpresa from './OpcoesPaginacaoSelecaoEmpresa';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import SetasPaginacaoSelecaoEmpresa from './SetasPaginacaoSelecaoEmpresa';
import filtrarSelecaoEmpresa from '../../actions/selecao-empresa/filtrarSelecaoEmpresa';
import limparFiltroSelecaoEmpresa from '../../actions/selecao-empresa/limparFiltroSelecaoEmpresa';
import alterarRegistrosPorPagina from '../../actions/selecao-empresa/alterarRegistrosPorPaginaSelecaoEmpresa';
import determinarPaginaAtual from '../../actions/selecao-empresa/determinarPaginaAtualSelecaoEmpresa';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN,
  PERFIL_ADMIN_EMPRESA,
  PERFIL_GESTOR_EMPRESA,
  PERFIL_OPERADOR_EMPRESA
} from '../../security/securityContext';

const CARD_COLORS = [
  '#FF6A00', '#0ea5e9', '#8b5cf6', '#10b981', '#f59e0b',
  '#ef4444', '#06b6d4', '#ec4899', '#16a34a', '#6366f1',
  '#dc2626', '#0284c7', '#7c3aed', '#059669', '#d97706'
];

function getInitials(nome) {
  if (!nome) return '?';
  return nome
    .split(' ')
    .filter(p => p.length > 2)
    .slice(0, 2)
    .map(p => p[0])
    .join('')
    .toUpperCase() || nome.substring(0, 2).toUpperCase();
}

export class PaginaSelecaoEmpresaAtuacao extends React.Component {
  constructor(props) {
    super(props);
    this.submeterBusca = this.submeterBusca.bind(this);
  }

  handleSelecionarEmpresa(empresa) {
    this.props.limparViagens();
    this.props.alterarEmpresaSelecionada(empresa);
    this.props.history.push('/gestao-empresa')
  }

  componentDidMount() {
    this.props.alterarRegistrosPorPagina(12);
    this.props.determinarPaginaAtual(1);
    this.props.limparFiltroSelecaoEmpresa();
  }

  submeterBusca(event) {
    this.props.alterarRegistrosPorPagina(12);
    this.props.determinarPaginaAtual(1);
    this.props.filtrarSelecaoEmpresa(this.props.empresasInicial, event.target.value);
  }

  exibirCard(empresa, idx) {
    const usarPlaceholder = isAmbienteDev() || !empresa.urlImagem;
    const cor = CARD_COLORS[idx % CARD_COLORS.length];

    return (
      <div
        key={`empresa-selecao-${empresa.id}`}
        className="vx-company-card"
        onClick={() => this.handleSelecionarEmpresa(empresa)}
        title={empresa.nome}
      >
        {usarPlaceholder ? (
          <div className="vx-company-card__placeholder" style={{ background: cor }}>
            <div className="vx-company-card__initials">{getInitials(empresa.nome)}</div>
            <div className="vx-company-card__name">{empresa.nome}</div>
            {empresa.nomeFantasia && empresa.nomeFantasia !== empresa.nome && (
              <div className="vx-company-card__fantasy">{empresa.nomeFantasia}</div>
            )}
            <span className="vx-company-card__select-hint">Selecionar</span>
          </div>
        ) : (
          <div className="vx-company-card__img-wrap">
            <img alt={empresa.nome} src={empresa.urlImagem} className="vx-company-card__img" />
            <div className="vx-company-card__overlay">{empresa.nome}</div>
            <span className="vx-company-card__select-hint">Selecionar</span>
          </div>
        )}
      </div>
    );
  }

  exibirEmpresas() {
    if (!this.props.empresas) return '';

    const empresas = elementosPaginaAtual(
      this.props.empresas,
      this.props.paginaAtual,
      this.props.registrosPorPagina
    );

    return (
      <CabecalhoRodapeTabela
        OpcoesPaginacao={OpcoesPaginacaoSelecaoEmpresa}
        BotoesPaginacao={SetasPaginacaoSelecaoEmpresa}
        empresas={this.props.empresas}
      >
        <div className="vx-company-grid">
          {empresas.map((empresa, idx) => this.exibirCard(empresa, idx))}
        </div>
      </CabecalhoRodapeTabela>
    );
  }

  render() {
    return (
      <div className="vx-company-page">
        <div className="vx-company-header">
          <div className="vx-company-header__icon">
            <i className="material-icons">store</i>
          </div>
          <h3 className="vx-company-header__title">Selecione a empresa que deseja atuar</h3>
        </div>

        <div className="vx-company-search">
          <i className="material-icons vx-company-search__icon">search</i>
          <input
            className="vx-company-search__input"
            type="text"
            autoComplete="off"
            onChange={this.submeterBusca}
            placeholder="Buscar empresa pelo nome..."
          />
        </div>

        <div className="vx-company-actions">
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN, PERFIL_GESTOR_EMPRESA, PERFIL_OPERADOR_EMPRESA, PERFIL_ADMIN_EMPRESA]}>
            <button
              className="vx-btn-primary"
              onClick={() => this.props.history.push('/painel-vendas-geral')}
            >
              <i className="material-icons" style={{ fontSize: '16px' }}>receipt</i>
              Passagens Vendidas
            </button>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <button
              className="vx-btn-primary"
              onClick={() => this.props.history.push('/painel-gerencial')}
            >
              <i className="material-icons" style={{ fontSize: '16px' }}>dashboard</i>
              Gerencial
            </button>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <button
              className="vx-btn-secondary"
              onClick={() => this.props.history.push('/painel-disponiveis-internet')}
            >
              <i className="material-icons" style={{ fontSize: '16px' }}>public</i>
              Disponíveis para Internet
            </button>
          </Autorizacao>
        </div>

        {this.exibirEmpresas()}
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    empresas: state.authentication.empresasSelecao,
    empresasInicial: state.authentication.empresas,
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualSelecaoEmpresa,
    registrosPorPagina: state.registrosPorPaginaSelecaoEmpresa
  }
}

export default withRouter(connect(mapStateToProps, {
  alterarEmpresaSelecionada,
  limparViagens,
  filtrarSelecaoEmpresa,
  limparFiltroSelecaoEmpresa,
  alterarRegistrosPorPagina,
  determinarPaginaAtual
})(PaginaSelecaoEmpresaAtuacao))
